import React from "react";

export function NotFoundPage() {
    return (
        <>
            <span>Not found</span>
        </>
    )
}